'use strict';

var AppDispatcher = require('dispatcher/SchedulerAppDispatcher');
var ActionTypes = require('constants/AppConstants').ActionTypes;

var SessionActionCreators = {

    loggedIn(userName, token, applicantId, texts) {
        AppDispatcher.dispatch({
            type: ActionTypes.LOGGED_IN,
            userName,
            token,
            applicantId,
            texts
        });
    },

    loggedOut() {
        AppDispatcher.dispatch({
            type: ActionTypes.LOGGED_OUT
        });
    },

    signIn(email, pass, onSuccess, onFailure) {
        AppDispatcher.dispatch({
            type: ActionTypes.SIGN_IN,
            email: email,
            pass: pass,
            onSuccess: onSuccess,
            onFailure: onFailure
        });
    },

    permissionRequestUpdate(userName, token, applicantId) {
        AppDispatcher.dispatch({
            type: ActionTypes.PERMISSION_REQUEST_UPDATE,
            userName,
            token,
            applicantId
        });
    },

    permissionUpdated() {
        AppDispatcher.dispatch({
            type: ActionTypes.PERMISSION_UPDATED
        });
    },

    signUp(userForm) {
        AppDispatcher.dispatch({
            type: ActionTypes.SIGN_UP,
            userForm: userForm
        });
    }
};

module.exports = SessionActionCreators;



/** WEBPACK FOOTER **
 ** ./src/actions/SessionActionCreators.js
 **/